import React from 'react';
import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    Typography,
    Stack,
    Chip,
    Box,
    Divider
} from '@mui/material';
import { CenterType } from '../../../../../../../services/ConfigurationService/types/centerType';

interface CenterListItemProps {
    center: CenterType;
    isSelected: boolean;
    showDivider: boolean;
    onToggle: () => void;
}

const formatAddress = (center: CenterType) => {
    const { address } = center;
    const parts = [
        address.address1,
        address.city,
        address.state,
        address.zip
    ].filter(Boolean);
    return parts.join(', ');
};

export const CenterListItem: React.FC<CenterListItemProps> = ({
    center,
    isSelected,
    showDivider,
    onToggle
}) => {
    return (
        <React.Fragment>
            {showDivider && <Divider />}
            <ListItem
                onClick={onToggle}
                sx={{
                    cursor: 'pointer',
                    bgcolor: isSelected ? 'action.selected' : 'inherit',
                    '&:hover': { bgcolor: isSelected ? 'action.selected' : 'action.hover' }
                }}
            >
                <ListItemIcon>
                    <Checkbox
                        checked={isSelected}
                        onClick={(e) => e.stopPropagation()}
                        onChange={onToggle}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Box>
                            <Typography variant="subtitle1">
                                {center.name}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {center.code} • {center.shortName}
                                </Typography>
                                <Chip
                                    label={center.centerType}
                                    size="small"
                                    variant="outlined"
                                />
                                {center.isInactive && (
                                    <Chip
                                        label="Inactive"
                                        color="warning"
                                        size="small"
                                    />
                                )}
                            </Stack>
                        </Box>
                    }
                    secondary={
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                                {formatAddress(center)}
                            </Typography>
                            {center.contactInfo.phone && (
                                <Typography variant="body2" color="text.secondary">
                                    Phone: {center.contactInfo.phone}
                                </Typography>
                            )}
                        </Box>
                    }
                />
            </ListItem>
        </React.Fragment>
    );
};
